import styled from 'styled-components';

import CarrierVehicleDeleteModal from './component';

export default styled(CarrierVehicleDeleteModal)`
  .carrier-vehicle-delete-modal {
    &__delete-content {
      display: flex;
      flex-direction: column;
    }

    &__delete-content-text {
      display: block;
      margin-bottom: 1rem;
    }

    &__delete-content-field {
      width: 100%;
    }

    &__delete-content-actions {
      display: flex;
      margin: 1rem 0;
      justify-content: flex-end;
    }
  }
`;
